export const SITE = {
  name: "Fusion Glass",
  domain: "https://fusionglass.com.au",
  phoneMain: "+61485032854",
  phoneMainDisplay: "0485 032 854",
  phoneEmergency: "+61414782514",
  phoneEmergencyDisplay: "0414 782 514",
  hours: "Monday to Saturday, 7am - 7pm",
  hoursShort: "Mon - Sat, 7am - 7pm",
  emergencyNote: "Calls available 24/7 for emergency glass",
  reviewUrl: "https://g.page/r/CbWE9yKhDWLxEBM/review",
};

export const CLIENT_TYPES =
  "homeowners, builders, home renovators, interior designers and architects";

export const COMMITMENTS = [
  {
    title: "On-site replacement service",
    text: "We come to you. Repairs and replacements carried out on-site for added convenience.",
  },
  {
    title: "Australian-made products",
    text: "Australian-made glass products recommended whenever possible.",
  },
  {
    title: "AS 1288 compliant",
    text: "All products and installations meet the latest Australian Standard AS 1288 for safety and quality.",
  },
  {
    title: "Free quotes, no obligation",
    text: "Clear, honest pricing with free on-site quotes before any work begins.",
  },
  {
    title: "Made-to-measure",
    text: "Custom solutions tailored to your exact space - no awkward gaps, no compromises.",
  },
  {
    title: "Guaranteed workmanship",
    text: "Workmanship guarantees plus full manufacturer and installation warranties.",
  },
  {
    title: "Family owned and run",
    text: "Fusion Glass is a small family business - three main installers and one admin. You deal with the same people from your first call to the finished job.",
  },
  {
    title: "No subcontractors, ever",
    text: "Our own team handles every job from measure-up to handover. No subcontractors, so the quality and accountability never leave our hands.",
  },
];

export const REGIONS = [
  {
    name: "Western Sydney",
    suburbs: ["Blacktown", "Penrith", "Parramatta", "Mount Druitt", "Liverpool", "Fairfield", "Campbelltown", "Auburn", "St Marys", "Baulkham Hills", "Wentworthville", "Westmead", "Merrylands", "Seven Hills", "Richmond", "Glenmore Park", "Windsor", "Castle Hill"],
  },
  {
    name: "Inner West",
    suburbs: ["Newtown", "Balmain", "Marrickville", "Leichhardt", "Petersham", "Annandale", "Dulwich Hill", "Stanmore", "Rozelle", "Ashfield", "Camperdown", "Tempe", "Hurlstone Park", "Summer Hill", "Croydon", "Haberfield"],
  },
  {
    name: "Eastern Suburbs",
    suburbs: ["Bondi", "Coogee", "Randwick", "Vaucluse", "Dover Heights", "Bronte", "Tamarama", "Clovelly", "Paddington", "Woollahra", "Bellevue Hill", "Kingsford", "Maroubra", "Bondi Junction", "Rose Bay", "Double Bay"],
  },
  {
    name: "Northern Beaches",
    suburbs: ["Manly", "Dee Why", "Narrabeen", "Freshwater", "Mona Vale", "Avalon", "Palm Beach", "Warriewood", "Balgowlah", "Queenscliff", "Collaroy", "Brookvale", "North Curl Curl", "North Narrabeen", "Clontarf"],
  },
  {
    name: "Southern Sydney",
    suburbs: ["Sutherland", "Cronulla", "Kogarah", "Hurstville", "Miranda", "Caringbah", "Rockdale", "Sylvania", "Beverly Hills", "Engadine", "Kirrawee", "Blakehurst", "Penshurst", "Bexley", "Mortdale"],
  },
  {
    name: "North Shore",
    suburbs: ["North Sydney", "Crows Nest", "Neutral Bay", "Mosman", "St Leonards", "Chatswood", "Willoughby", "Lindfield", "Artarmon", "Hornsby", "Wahroonga", "Turramurra", "Pymble", "Gordon", "Killara", "East Lindfield", "Roseville"],
  },
  {
    name: "Hills District",
    suburbs: ["Castle Hill", "Baulkham Hills", "Kellyville", "Rouse Hill", "Cherrybrook", "Norwest", "Glenhaven", "Beaumont Hills", "Bella Vista", "Dural", "Winston Hills", "Seven Hills", "Northmead", "Kings Langley"],
  },
  {
    name: "Sydney CBD",
    suburbs: ["Darlinghurst", "Surry Hills", "Pyrmont", "Ultimo", "Haymarket", "The Rocks", "Barangaroo", "Chippendale", "Woolloomooloo", "Potts Point", "Redfern", "Darling Harbour"],
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Free on-site quote",
    text: "We visit, measure and advise - then give you a clear, no-obligation price.",
  },
  {
    step: "02",
    title: "Made-to-measure manufacture",
    text: "Your glass is custom made to your exact measurements and finished to suit your space.",
  },
  {
    step: "03",
    title: "Expert installation",
    text: "Installed by experienced glaziers, compliant with AS 1288 and backed by our workmanship guarantee.",
  },
];
